<template>
  <div class="d-flex align-items-center flex-gap-1">
    <eg-dropdown
      id="export-dropdown"
      v-b-tooltip.hover
      :title="disabled ? tooltipText : ''"
      :disabled="disabled"
      class="export-dropdown cancel-default-disabled-styles"
      size="sm"
      right
      variant="outline-info"
      :text="$t('common.export')"
      menu-class="export-dropdown-menu"
    >
      <template #button-content>
        <eg-button
          type="secondary"
          icon="upload"
          right-icon="chevron-down"
          size="extra-small"
          :disabled="disabled"
        >
          {{ $t("common.export") }}
        </eg-button>
      </template>

      <eg-b-dropdown-item
        v-if="isGoogleFolder"
        :disabled="!isFolderConnected"
        @click="exportTo('google')"
      >
        {{ $t("imports.lms.googleClassroom") }}
      </eg-b-dropdown-item>
      <eg-b-dropdown-item
        v-if="isCanvasFolder"
        :disabled="!isFolderConnected && !features.bulkImports"
        @click="exportTo('canvas')"
      >
        {{ $t("imports.lms.canvas") }}
      </eg-b-dropdown-item>
      <eg-b-dropdown-item @click="exportTo('pdf')"> PDF </eg-b-dropdown-item>
      <eg-b-dropdown-item
        v-if="isSeveralSelected"
        @click="exportTo('pdf', 'merged-pdf')"
      >
        {{ $t("essays.exportSinglePdf") }}
      </eg-b-dropdown-item>
      <eg-b-dropdown-item @click="exportTo('csv')"> CSV </eg-b-dropdown-item>
    </eg-dropdown>

    <div v-b-tooltip.hover.top :title="disabled ? tooltipText : ''">
      <eg-button
        id="delete-button-wrapper"
        size="extra-small"
        color="danger"
        type="secondary"
        icon="delete"
        data-testid="delete-button"
        :disabled="disabled"
        @click="onClickDelete"
      >
        {{ $t("essays.deleteSubmissions") }}
      </eg-button>
    </div>
  </div>
</template>

<script>
import { PLATFORMS } from "@/constants";
import deleteConfirmationModalMixin from "@/mixins/deleteConfirmationModal";
import { mapGetters } from "vuex";

export default {
  name: "EssayActions",

  // this.showDeleteConfirmationModal
  mixins: [deleteConfirmationModalMixin],
  inject: ["workspacesProvider"],

  props: {
    selectedAll: {
      type: Boolean,
      default: false,
    },

    selectedIds: {
      type: Array,
      default: () => [],
    },
    disabled: Boolean,
  },

  computed: {
    ...mapGetters("config", ["features"]),

    tooltipText() {
      return this.$t("essays.selectToUseAction");
    },

    folder() {
      return this.workspacesProvider.getFolderById(
        this.$route.params.workspaceKey,
        this.$route.params.id
      );
    },
    platform() {
      return this.folder?.platform;
    },
    isGoogleFolder() {
      return this.platform === PLATFORMS.GOOGLE;
    },
    isCanvasFolder() {
      return this.platform === PLATFORMS.CANVAS;
    },
    isFolderConnected() {
      return this.folder?.isConnected || false;
    },
    isSeveralSelected() {
      return this.selectedIds?.length > 1;
    },
  },

  methods: {
    exportTo(type, modalType) {
      this.$emit("export", {
        type,
        selectedIds: this.selectedIds,
        mergedPdf: modalType === "merged-pdf",
      });
    },

    onClickDelete() {
      const count = this.selectedAll ? 0 : this.selectedIds.length;
      this.showDeleteConfirmationModal({
        title: this.$tc("essays.confirmDeleteEssays", count, { count }),
        message: this.$t("essays.essaysDeletedInfo"),
      })
        .then((value) => {
          if (value) {
            this.$emit("delete", this.selectedIds);
          }
        })
        .catch((err) => {
          console.log(err);
          // An error occurred
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.export-dropdown {
  &::v-deep {
    .dropdown-toggle {
      padding: 0;
      border: none;
    }
    .btn {
      background-color: transparent;
      color: var(--color-stroke-primary);

      &:hover {
        color: var(--color-surface-primary-hover);
      }
    }
  }
}
</style>
